import { render, staticRenderFns } from "./CloseCircleOutline.vue?vue&type=template&id=6b0dace3"
import script from "./CloseCircleOutline.vue?vue&type=script&lang=js"
export * from "./CloseCircleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports